// import { IconDefinition, IconLookup } from '@fortawesome/fontawesome-svg-core';

const prefix = 'fac';
const iconName = 'table';
const width = 13;
const height = 13;
const ligatures = [];
const unicode = null;
const svgPathData = `M12.5 0 C12.7761424 0 13 0.223857625 13 0.5 L13 12.5 C13 12.7761424 12.7761424 13 12.5 13 L0.5 13 C0.223857625 13 0 12.7761424 0 12.5 L0 0.5 C0 0.223857625 0.223857625 0 0.5 0 L12.5 0 Z M12 9 L1 9 L1 12 L12 12 L12 9 Z M12 5 L1 5 L1 8 L12 8 L12 5 Z M12 1 L1 1 L1 4 L12 4 L12 1 Z`;

// export interface CustomIconConstruct extends IconDefinition, IconLookup {}

export const faTable = {
  // Use a prefix like 'fac' that doesn't conflict with a prefix in the standard Font Awesome styles
  // (So avoid fab, fal, fas, far, fa)
  prefix,
  iconName, // Any name you like
  icon: [
    width, // width
    height, // height
    ligatures, // ligatures
    unicode, // unicode (if relevant)
    svgPathData, // svg path data
  ],
};
